import Vue from "vue";
import { Container, Constructable } from "typedi";
import { AppModule } from "@/core/types/app-module";
import { CoreSymbols } from "@/core/core.symbols";
import { router } from "@/core/router";
import { store } from "@/core/store";

Container.set(CoreSymbols.router, router);
Container.set(CoreSymbols.store, store);

// eslint-disable-next-line @typescript-eslint/ban-types
function defineContainer(object: Object, container: typeof Container) {
  Object.defineProperty(object, "$container", {
    get() {
      return container;
    },
  });
}

export async function bootstrap(modules: Constructable<AppModule>[]): Promise<void> {
  defineContainer(Vue, Container);
  defineContainer(Vue.prototype, Container);

  for (let index = 0; index < modules.length; index += 1) {
    // eslint-disable-next-line no-await-in-loop
    await Container.get(modules[index]).install(Vue);
  }
}
